export default {"src":"/org/_next/static/media/close.8dfe09ce.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};